import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { toast } from "sonner";
import api, { fmtINR, fmtDate } from "@/lib/api";

export default function AdminFinance() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/finance-support").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const decide = async (id, decision) => {
    try { await api.post(`/admin/finance-support/${id}/decision`, { decision }); toast.success(`Request ${decision}d`); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="admin-finance-page">
      <h1 className="text-3xl font-extrabold tracking-tight">Finance Support Requests</h1>
      <p className="text-sm text-slate-500">Review customer premium finance requests</p>

      <div className="mt-5 bg-white border border-slate-100 rounded-2xl card-shadow table-scroll">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500 font-bold">
            <tr>
              <th className="text-left p-3">Customer</th>
              <th className="text-right p-3">Amount</th>
              <th className="text-right p-3">Interest</th>
              <th className="text-right p-3">Total</th>
              <th className="text-center p-3">Status</th>
              <th className="text-right p-3">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {list.map((f) => (
              <tr key={f.id} data-testid={`fs-row-${f.id}`}>
                <td className="p-3">
                  <div className="font-bold">{f.customer_name}</div>
                  <div className="text-[10px] text-slate-400">{fmtDate(f.created_at)}</div>
                </td>
                <td className="p-3 text-right font-extrabold">{fmtINR(f.amount)}</td>
                <td className="p-3 text-right text-slate-600">{fmtINR(f.interest_amount)}</td>
                <td className="p-3 text-right font-extrabold text-tenant-primary">{fmtINR(f.total_payable)}</td>
                <td className="p-3 text-center"><Status status={f.status} /></td>
                <td className="p-3 text-right">
                  {f.status === "pending" && (
                    <div className="flex gap-2 justify-end">
                      <button data-testid={`approve-fs-${f.id}`} onClick={() => decide(f.id, "approve")} className="bg-emerald-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold">Approve</button>
                      <button data-testid={`reject-fs-${f.id}`} onClick={() => decide(f.id, "reject")} className="bg-rose-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold">Reject</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={6} className="text-center p-6 text-slate-400">No requests.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Status = ({ status }) => {
  const map = {
    pending: { c: "bg-amber-50 text-amber-700", I: Clock },
    approved: { c: "bg-emerald-50 text-emerald-700", I: CheckCircle2 },
    rejected: { c: "bg-rose-50 text-rose-700", I: XCircle },
  };
  const { c, I } = map[status] || map.pending;
  return <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${c}`}><I className="w-3 h-3" />{status}</span>;
};
